<template>
    <footer class="app-footer">
        <div class="float-left">
            © 2010-2019 Аларм.ру
            <a href="http://www.facebook.com/alarmcenterru" target="_blank" type="button" class="btn btn-facebook icon btn-sm"></a>
            <a href="http://vk.com/alarmru" type="button" target="_blank" class="btn btn-vk icon btn-sm"></a>
            <a href="http://twitter.com/alarmcentr" type="button" target="_blank" class="btn btn-twitter icon btn-sm"></a>
            <a href="https://www.youtube.com/c/AlarmcenterRu?sub_confirmation=1" type="button" target="_blank" class="btn btn-youtube icon btn-sm"></a>
            <a href="https://www.instagram.com/alarm_ru/" type="button" target="_blank" class="btn btn-instagram icon btn-sm"></a>
            <br>
            <a href="http://feedback.alarmplan.ru/" target="_blank">Замечания и предложения</a>
        </div>
        <div class="float-right">
            <span class="">Отдел продаж&nbsp;&nbsp;&nbsp;<i class="fa fa-phone"></i>&nbsp;+7&nbsp;903 724-81-17</span><br>
            <span class="">Техподдержка&nbsp;&nbsp;<i class="fa fa-envelope"></i> <a href="mailto:anton@alarm.ru">anton@alarm.ru</a>&nbsp; &nbsp;<i class="fa fa-phone"></i>&nbsp;+7 495 733-99-81</span>
        </div>
    </footer>
</template>
<script>
  export default {
    name: 'footer'
  }
</script>



// WEBPACK FOOTER //
// Footer.vue?cd2f5ec8